import React from 'react';

import { Box, Button, Dialog, H1, Table, Tag, Text } from '@betterment/samba-react';

import { PlatformFeeTier } from '../../../../graphql/schema';

const PlatformFeeExplanationModal: React.FC<{
  isOpen: boolean;
  closeHandler: () => void;
  rows: PlatformFeeTier[] | null;
}> = ({ isOpen, closeHandler, rows }) => {
  const generateRows = (tiers: PlatformFeeTier[]) => {
    return tiers.map((tier, index) => {
      const isFirst = index === 0;
      const toMillions = value => {
        return value / 100000000;
      };
      // @ts-expect-error TS2533 violates strict null checks
      const tierStart = isFirst ? 0 : `${toMillions(tiers[index - 1].tierEnd.cents)}`;
      const aumRange = tier.tierEnd === null ? `$${tierStart}M+` : `$${tierStart}-$${toMillions(tier.tierEnd.cents)}M`;

      return (
        <Table.Row key={`${tierStart}-${tier.fee}`}>
          <Table.Cell css={{ py: 'space.300' }}>{aumRange}</Table.Cell>
          <Table.Cell css={{ py: 'space.300' }}>
            {tier.fee} bps
            {isFirst ? (
              <Tag accent="teal" css={{ ml: 'space.100' }}>
                Starting tier
              </Tag>
            ) : (
              ''
            )}
          </Table.Cell>
        </Table.Row>
      );
    });
  };

  return (
    <Dialog open={isOpen} overlay="default" onOpenChange={closeHandler}>
      <Dialog.Content
        css={{
          display: 'flex',
          flexDirection: 'column',
          minWidth: '640px',
          p: 'space.400',
          overflow: 'auto',
          pb: 'space.0',
        }}
      >
        <Dialog.Title asChild={true}>
          <H1 variant="title300" css={{ pb: 'space.150' }}>
            Betterment platform fee
          </H1>
        </Dialog.Title>
        <Dialog.Description>
          <Text>
            This table shows the platform fee Betterment charges your clients, based on your firm’s total assets on our
            platform. We review assets at the start of each quarter and apply the corresponding tiered fee.
          </Text>
        </Dialog.Description>

        <Box
          css={{
            border: 'token(borderWidths.thin) solid token(colors.border)',
            borderRadius: 'large',
            mt: 'space.200',
          }}
        >
          <Table>
            <Table.Header css={{ paddingTop: 'space.100' }}>
              <Table.Row>
                <Table.ColumnHeaderCell>Total firm AUM</Table.ColumnHeaderCell>
                <Table.ColumnHeaderCell>Betterment platform fee</Table.ColumnHeaderCell>
              </Table.Row>
            </Table.Header>
            {/* @ts-expect-error TS2345 violates strict null checks */}
            <Table.Body>{generateRows(rows)}</Table.Body>
          </Table>
        </Box>
        <Text css={{ my: 'space.300' }}>
          Betterment platform fee does not include any additional fee that you or your firm’s advisors charge via
          Betterment’s platform.
        </Text>
        <Button
          data-testid="modal-close-button"
          variant="solidSecondary"
          css={{ width: '90px', mb: 'space.400' }}
          onClick={closeHandler}
        >
          Close
        </Button>
      </Dialog.Content>
    </Dialog>
  );
};

export default PlatformFeeExplanationModal;
